import { Insights } from "../../Dashboard/Widgets/Insights";
import { useCurrentGroup } from "../../../hooks/useGroups";

export function GroupInsights() {
  const { groupFormData } = useCurrentGroup();

  if (!groupFormData) {
    return null;
  }

  return (
    <Insights
      groupId={ groupFormData.id }
      hideFilters
      title={ `${groupFormData.title} Insights` }
    />
  );
}
